import { Box, Card, Divider, Typography } from '@mui/material';
import CustomButton from 'components/shared/Buttons/CustomButton';
import text from '../../shared/css/text.module.scss';
import styles from './pricingPlan.module.scss';

const CurrentPlanCard = ({ title, handleClickButton, selectedPlan, isYearly, buttonDetails, discountPercent, isFreeTrial = false, showActionBtn = true }) => {
    const originalPrice = isYearly ? selectedPlan?.yearlyPrice * 12 : selectedPlan?.monthlyPrice;
    const discountedPrice = discountPercent
        ? (originalPrice - (originalPrice * discountPercent) / 100).toFixed(2)
        : originalPrice;



    return (
        <Card className={styles.subscriptionPlanCard}>
            <Typography variant="body1" fontWeight="bold">{title}</Typography>
            <div className={styles.innerCard}>
                <div className={styles.flexContainer}>
                    <div className={styles.planDetail}>
                        <Typography variant="body1" fontWeight="bold">
                            {selectedPlan?.name} Subscription Package
                        </Typography>

                        {/* Price Display with Discount */}
                        {discountPercent > 0 ? (
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography
                                    fontWeight="bold"
                                    className={styles.lineThrough}
                                >
                                    <b>${originalPrice}</b>
                                </Typography>
                                <Typography fontWeight="bold" className={text.info1} color="primary.main">
                                    <b>${discountedPrice}</b>/ Per {isYearly ? "Year" : "Month"}
                                </Typography>
                            </Box>
                        ) : (
                            <Typography fontWeight="bold" className={text.info1}>
                                    <b>${originalPrice}/</b>Per {isYearly ? "Year" : "Month"}
                            </Typography>
                        )}


                    </div>
                    {/* Action Button */}
                    {showActionBtn &&
                        <CustomButton
                            padding={"0px 30px"}
                            color={buttonDetails.color}
                            bgColor={buttonDetails.bgColor}
                            hover={buttonDetails.hover}
                            label={buttonDetails.label}
                            onClick={handleClickButton}
                            type={"text"}
                        />
                    }
                </div>
                {isFreeTrial &&
                    <>
                        <Divider />
                        <span className={styles.trialBox}>
                            Free Trial
                        </span>
                    <Typography variant="body2" fontWeight="bold">
                        Get started with a <span className={styles.pricingInfo}>1-month free trial</span>.
                        <span style={{ fontWeight: 600 }}> No payment today</span> —
                        <span className={styles.pricingInfo}>{isYearly ? "$948/Year" : "$99/Month"}  </span> begins after the trial ends.
                    </Typography>
                    </>}
            </div>


        </Card>
    );
}

export default CurrentPlanCard;
